(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["okendo-grouped-drp"] && !Shopify.designMode) return;
  try {
    
((document, window) => {
    const okeRenderedHandler = function(e) {
        if (e.detail.widget === 'reviews-widget') {
            setupCollectionControls();
       }
    }
  
    document.addEventListener('oke-rendered', okeRenderedHandler);
  
    if (!String.prototype.startsWith) {
        Object.defineProperty(String.prototype, 'startsWith', {
            value: function(search, rawPos) {
                var pos = rawPos > 0 ? rawPos|0 : 0;
                return this.substring(pos, pos + search.length) === search;
            }
        });
    }
  
    function setupCollectionControls() {
        const snippetEl = document.querySelector('#orc-widget-snippet');
        const controlEl = document.querySelector('#orc-collection-control');
        const collectionRadioElements = Array.prototype.slice.call(document.querySelectorAll('.js-orc-collectionRadio'));
        controlEl.style.display = 'block';
        collectionRadioElements.forEach(function (radioElement) {
            radioElement.addEventListener('change', function () {
                if (radioElement.value) {
                    if(radioElement.value.toLowerCase().startsWith('shopify-')) {
                        snippetEl.removeAttribute('data-oke-reviews-group-id');
                        window.okeWidgetApi.setProduct(snippetEl, radioElement.value);
                    }
                    else {
                        snippetEl.removeAttribute('data-oke-reviews-product-id');
                        window.okeWidgetApi.setGroup(snippetEl, radioElement.value);
                    }
                }
                else {
                    snippetEl.removeAttribute('data-oke-reviews-group-id');
                    snippetEl.removeAttribute('data-oke-reviews-product-id');
                    snippetEl.innerHTML = '';
                    window.okeWidgetApi.initWidget(snippetEl, true);
                }

                collectionRadioElements.forEach(function (element) {
                    element.classList.remove('orc-collectionControls-item-input--checked');
                });
                radioElement.classList.add('orc-collectionControls-item-input--checked');
            });
        });
  
        document.removeEventListener('oke-rendered', okeRenderedHandler);
    }
})(document, window);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
